import { Plus, Pencil, Trash2, Key } from "lucide-react";

const AdminUsersTab = ({ adminUsers, onAdd, onEdit, onResetPassword, onDelete }) => (
  <div className="bg-white border border-[#E6E4DD]">
    <div className="p-6 border-b border-[#E6E4DD] flex justify-between items-center">
      <h2 className="font-medium text-[#1C1C1A]">Admin Users</h2>
      <button onClick={onAdd} className="btn-primary text-xs py-2 px-4 flex items-center gap-1" data-testid="add-admin-btn">
        <Plus size={14} /> Add Admin
      </button>
    </div>
    <div className="overflow-x-auto">
      <table className="admin-table">
        <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Actions</th></tr></thead>
        <tbody>
          {adminUsers.map(a => (
            <tr key={a.id}>
              <td className="font-medium">{a.name}</td>
              <td className="text-sm text-[#6B6A65]">{a.email}</td>
              <td><span className="px-2 py-1 text-xs bg-[#4A5D4E]/10 text-[#4A5D4E]">{a.role}</span></td>
              <td>
                <div className="flex items-center gap-2">
                  <button onClick={() => onEdit(a)} className="p-2 hover:bg-[#F7F5F0]" data-testid={`edit-admin-${a.id}`}><Pencil size={16} className="text-[#6B6A65]" /></button>
                  <button onClick={() => onResetPassword(a)} className="p-2 hover:bg-[#F7F5F0]" data-testid={`reset-pw-${a.id}`}><Key size={16} className="text-[#6B6A65]" /></button>
                  <button onClick={() => onDelete(a.id)} className="p-2 hover:bg-red-50" data-testid={`delete-admin-${a.id}`}><Trash2 size={16} className="text-red-500" /></button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default AdminUsersTab;
